import React from 'react'
import SubAdminDetails from './SubAdminDetails'
import SubAdminDetailsHeader from './SubAdminDetailsHeader'

const SubAdminDetailsPage = ({data}: any) => {
  return (
    <section>
      <SubAdminDetails />
    </section>
  )
}

export default SubAdminDetailsPage
